import React from "react";

export default function faqs(): { question: React.ReactNode, answer: React.ReactNode }[] {
  return [
    {
      question: <>Is my server belongs only to me?</>,
      answer: <>Yes. We do not share your server with anyone else. It is a real server and no else (even ZEST employees)
        do not have access to it.</>,
    },
    {
      question: <>How can I access my server?</>,
      answer: <>You can access to services running on your server with our clients or using regular email clients like
        outlook, apple mail etc.</>,
    },
    {
      question: <>Which VPN client should I use?</>,
      answer:
        <>Your VPN server is using WireGuard, it&apos;s the best in the business. You can use any client that supports
          WireGuard, we recommend the official WireGuard clients for iOS, Android, MacOS, Windows, and Linux. You can
          also use the official WireGuard client for your router, or use the WireGuard client built into your router if
          it supports it or you can use our own clients.</>,
    },

    {
      question: <>Which email client should I use?</>,
      answer: <>You can use any email client you want, as long as they support IMAP, POP3 and SMTP. We recommend
        Thunderbird, Evolution, Apple Mail (iOS or macOS), Outlook, or any other client that supports these
        protocols.</>,
    },
    {
      question: <>How fast is my server&apos;s connection?</>,
      answer: <>Your server is connected to the internet with a 10 gbit connection. This is the fastest connection you
        can get anywhere in the world. We do not throttle your bandwidth in any way, you can use your full 10 gbit
        connection 24/7.</>,
    },
    {
      question: <>How much data transfer do I get?</>,
      answer:
        <>Your first 1TB of data is included in your monthly fee. If you need more, you can purchase additional data
          transfer for $10 per TB.</>,
    },

    {
      question: <>Do you store my credit card?</>,
      answer:
        <>We don&apos;t store credit card information, however you can opt in to have your credit card information
          stored with our payment processor, Stripe. If you opt in, your credit card information is stored with Stripe,
          not with us. We do not have access to your credit card information.</>,
    },
    {
      question: <>Can we expect more features?</>,
      answer: <>Yes, we are working on more features. We will be adding more features to your server in the future, and
        you will get them for free.</>,
    },
    {
      question: <>Do I own the domain name?</>,
      answer: <>Yes, you own the domain name. You can transfer it to another registrar at any time. It&apos;s your
        domain name, you own it.</>,
    },
  ]
}
